"use client";

import type { FooterData, LanguageOption } from "../../types";
import { SiteFooterDesktop } from "./footer/SiteFooterDesktop";
import { SiteFooterMobile } from "./footer/SiteFooterMobile";

/** Site footer component props. */
export interface SiteFooterProps {
  data: FooterData;
  logoSrc: string;
  logoAlt?: string;
  /** Optional controlled language switch for the footer bottom bar. */
  language?: string;
  languageOptions?: LanguageOption[];
  onLanguageChange?: (code: string) => void;
  /** Builds the locale-prefixed URL for a language code. */
  resolveHref?: (code: string) => string;
}

/** Site footer with desktop and mobile versions. */
export function SiteFooter({
  data,
  logoSrc,
  logoAlt = "Banque Centrale du Congo",
  language,
  languageOptions,
  onLanguageChange,
  resolveHref,
}: SiteFooterProps) {
  return (
    <footer className="bg-[#005CA9] text-white">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-8 xl:py-12">
        <SiteFooterMobile
          data={data}
          logoSrc={logoSrc}
          logoAlt={logoAlt}
          language={language}
          languageOptions={languageOptions}
          onLanguageChange={onLanguageChange}
          resolveHref={resolveHref}
        />
        <SiteFooterDesktop
          data={data}
          logoSrc={logoSrc}
          logoAlt={logoAlt}
          language={language}
          languageOptions={languageOptions}
          onLanguageChange={onLanguageChange}
          resolveHref={resolveHref}
        />
      </div>
    </footer>
  );
}
